import { AttachmentsModel } from '@/features/attachment/_models/attachment';
import { z } from 'zod';
import { IndonesiaDataModel } from './indonesia-data';

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const RelatedMaterialModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  attachments: AttachmentsModel,
  additionalExplanation: z.string().nullish(),
});

export const RelatedMaterialsModel = z.array(RelatedMaterialModel);

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const RelatedMaterialFormSchema = IndonesiaDataModel.pick({
  evaluationOfProgramResults: true,
  usulanPerbaikan: true,
  referensiProgramYangSamaDiDaerahLain: true,
  catatan: true,
});

const _AlurDanaFormSchema = IndonesiaDataModel.pick({
  alurDana: true,
});

export const RelatedMaterialMutationParamsSchema = z.object({
  attachmentIds: z.string().uuid().array().optional(),
  additionalExplanation: RelatedMaterialModel.shape.additionalExplanation,
});
